import { BlockProps, IBlockLocation } from '../../content-blocks/type';
import { CaptionBlockProps } from './type';

interface Props {
  key: string;
  label: string;
  location: IBlockLocation;
}

export const createCaptionBlock = (props: Props): CaptionBlockProps => {
  return {
    type: 'caption',
    value: props.label,
    isVisible: false,
    x: 0,
    y: 0,
    fontSize: 12,
    isBold: false,
    isItalics: false,
    isCapsLocks: false,
    width: 0,
    ...props,
  };
};

export function isCaptionBlock(block: BlockProps): block is CaptionBlockProps {
  return block.type === 'caption';
}
